import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../config/firebase';

const ENV_PREFIX = process.env.REACT_APP_ENV || 'production';

export interface UploadProgress {
  progress: number;
  fileName: string;
}

/**
 * Validar archivo de imagen
 */
export const validateImageFile = (file: File): string | null => {
  // Validar tipo
  const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
  if (!validTypes.includes(file.type)) {
    return 'validation.image_type';
  }

  // Validar tamaño (10MB)
  const maxSize = 10 * 1024 * 1024;
  if (file.size > maxSize) {
    return 'validation.image_size';
  }
  
  return null;
};

/**
 * Validar archivo de video
 */
/*
export const validateVideoFile = async (file: File): Promise<string | null> => {
  // Validar tipo
  const validTypes = ['video/mp4', 'video/quicktime', 'video/x-msvideo'];
  if (!validTypes.includes(file.type)) {
    return 'Solo se permiten videos MP4, MOV o AVI';
  }
  
  // Validar tamaño (100MB)
  const maxSize = 100 * 1024 * 1024;
  if (file.size > maxSize) {
    return 'El video no debe superar 100MB';
  }
  
  // Validar duración (10 segundos)
  try {
    const duration = await getVideoDuration(file);
    if (duration > 10) {
      return 'El video no debe superar 10 segundos';
    }
  } catch (error) {
    return 'No se pudo validar la duración del video';
  }
  
  return null;
};
*/
export const validateVideoFile = async (file: File): Promise<string | null> => {
  const maxSize = 50 * 1024 * 1024; // 50MB
  const allowedTypes = ['video/mp4', 'video/quicktime', 'video/x-msvideo', 'video/webm'];

  // Validar tipo
  if (!allowedTypes.includes(file.type)) {
    return 'validation.video_type';
  }

  // Validar tamaño
  if (file.size > maxSize) {
    return 'validation.video_size';
  }

  // ⭐ NO HAY VALIDACIÓN DE DURACIÓN
  return null;
}
/**
 * Obtener duración de un video
 */
const getVideoDuration = (file: File): Promise<number> => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.preload = 'metadata';
    
    video.onloadedmetadata = () => {
      window.URL.revokeObjectURL(video.src);
      resolve(video.duration);
    };
    
    video.onerror = () => {
      reject(new Error('Error al cargar el video'));
    };
    
    video.src = URL.createObjectURL(file);
  });
};

/**
 * Subir imagen a Storage
 */
export const uploadImage = async (
  file: File,
  userId: string,
  type: 'horizontal' | 'vertical'
): Promise<string> => {
  try {
    const timestamp = Date.now();
    const fileName = `${userId}_${type}_${timestamp}.${file.name.split('.').pop()}`;
    const storagePath = `${ENV_PREFIX}/events/${userId}/${fileName}`;
    const storageRef = ref(storage, storagePath);

    console.log(`⬆️ Subiendo imagen ${type}:`, fileName);
    
    await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(storageRef);
    
    console.log(`✅ Imagen ${type} subida:`, downloadURL);
    
    return downloadURL;
  } catch (error) {
    console.error(`❌ Error subiendo imagen ${type}:`, error);
    throw new Error('errors.upload_image');
  }
};

/**
 * Subir video a Storage
 */
export const uploadVideo = async (
  file: File,
  userId: string
): Promise<string> => {
  try {
    const timestamp = Date.now();
    const fileName = `${userId}_video_${timestamp}.${file.name.split('.').pop()}`;
    const storagePath = `${ENV_PREFIX}/events/${userId}/${fileName}`;
    const storageRef = ref(storage, storagePath);

    console.log('⬆️ Subiendo video:', fileName);
    
    await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(storageRef);
    
    console.log('✅ Video subido:', downloadURL);
    
    return downloadURL;
  } catch (error) {
    console.error('❌ Error subiendo video:', error);
    throw new Error('errors.upload_video');
  }
};